import { PureComponent } from 'react';
import TableContext from './TableContext';
import { DataSetStatus } from '../data-set/enum';
export default class Profiler extends PureComponent {
    constructor(props, context) {
        super(props, context);
        const { tableStore, dataSet } = context;
        if (tableStore.performanceEnabled) {
            if (dataSet.status === DataSetStatus.ready && dataSet.length) {
                tableStore.performanceOn = true;
                tableStore.timing.renderStart = Date.now();
            }
        }
    }
    static get contextType() {
        return TableContext;
    }
    componentWillUpdate() {
        const { tableStore } = this.context;
        if (tableStore.performanceEnabled && tableStore.performanceOn) {
            tableStore.timing.renderStart = Date.now();
        }
    }
    componentDidMount() {
        this.handlePerformance();
    }
    componentDidUpdate() {
        this.handlePerformance();
    }
    handlePerformance() {
        const { code, tableStore, dataSet } = this.context;
        if (tableStore.performanceEnabled && tableStore.performanceOn) {
            const { timing } = tableStore;
            const { performance } = dataSet;
            const onPerformance = tableStore.getConfig('onPerformance');
            timing.renderEnd = Date.now();
            onPerformance('Table', {
                name: code,
                url: performance.url,
                size: dataSet.length,
                timing: {
                    ...performance.timing,
                    ...timing,
                },
            });
            tableStore.performanceOn = false;
        }
    }
    render() {
        const { children } = this.props;
        return children;
    }
}
Profiler.displayName = 'Profiler';
